import React, {useState, useEffect, useRef} from "react";
import {Form, Button, Container, Row, Col, Card} from "react-bootstrap";
import "./Department.css";
import user from "../../../images/user.jpg";
import CheckInimg from "../../../images/CheckInimg.png";
import {useForm} from "react-hook-form";
import axios from "../../util/Axios/AxiosInstance";
import {FiLogOut, FiLogIn} from "react-icons/fi";
import Modal from "react-bootstrap/Modal";
import AOS from "aos";
import "aos/dist/aos.css";
import Skeleton from "react-loading-skeleton";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/free-solid-svg-icons";


function Department() {

    // Helper function to format date with leading zeros
    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    // Helper function to format datetime with leading zeros
    const formatDateTime = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    const {
        register, formState: {errors},
    } = useForm();
    const onSubmit = (data) => {
    };
    const [showDep, setShowDep] = useState(false);
    const [showDepMsgI, setShowDepMsgI] = useState("");
    const [showDepMsgO, setShowDepMsgO] = useState("");
    const [showDepCO, setShowDepCO] = useState("");
    const handleClose = () => {
        setShowDepMsgI('');
        setShowDepMsgO('');
        setShowDepCO(prevState => prevState == true ? "" : prevState);
        setShowDep(false);
    };
    const handleShow = (e) => {
        e.preventDefault();
        setShowDep(true);
    };
    //const showSuccessMsgI = () => setShowDepMsgI(true);
    //const showSuccessMsgO = () => setShowDepMsgO(true);
    const showCheckOut = () => setShowDepCO(true);

    const checkOutBtn = (e) => {
        e.preventDefault();
        handleShow(e);
        showCheckOut();
    };

    const [showEmpDetails, setShowEmpDetails] = React.useState(false);
    // const onClickEmpName =  (empList.laborerId) => setShowEmpDetails(true);

    const [deptId, setDeptId] = useState("");
    const [subDeptId, setSubDeptId] = useState("");
    const [transactionDate, setTransactionDate] = useState("");
    const [deptName, setDeptName] = useState("");
    const [subDeptName, setSubDeptName] = useState("");
    const [branchId, setBranchId] = useState("");
    // const [transactionId, setTransactionId] = useState('')
    const [dataListNew, setDataListNew] = useState({});
    const [clTransactionId, setClTransactionId] = useState("");
    const labId1 = useRef("");
    const onClickEmpName = (dataList) => {
        // console.log(dataList);
        setDataListNew(dataList);
        setClTransactionId(dataList.clTransactionId);

        //     setLaborerId(dataList.labourId);
        labId1.current = dataList.labourId;
        setLaborerName(dataList.labourerName);
        setVendorId(dataList.vendorId);
        setVendorName(dataList.vendorName);
        setShiftId(dataList.shiftId);
        setShiftName(dataList.shiftName);
        //setTransactionId(dataList.transactionId);
        var currentdate = new Date();
        var datetime = formatDate(currentdate);
        setTransactionDate(dataList.currentdate);
        setDeptId(dataList.deptId);
        setSubDeptId(dataList.subDeptId);
        setDeptName(dataList.deptName);
        setSubDeptName(dataList.subDeptName);
        setBranchId(dataList.branchId);

        // Check if this labourer has a saved subdepartment assignment
        const savedAssignment = labourerSubDeptAssignments[dataList.labourId];
        if (savedAssignment) {
            setSubDeptId(savedAssignment.subDeptId);
            setSubDeptName(savedAssignment.subDeptName);
            // Update dataListNew with saved assignment
            dataList.subDeptId = savedAssignment.subDeptId;
            dataList.subDeptName = savedAssignment.subDeptName;
        }
        setShowEmpDetails(true);
        setDepartmentCheckIn("");
        setDepartmentCheckOut("");
        setSecurityCheckIn("");
        // Reset editing state when new labourer is selected
        setShowSubDeptDrop(false);
        setEditingLabourId(null);
        setSubDeptUpdated(false);
        getCheckInCheckOutDetails(datetime, labId1.current);
        // statusCheck();


        // getCheckCheckIn(datetime, labId1.current);
        // getDeptCheckIn(datetime, labId1.current);
        // getDeptCheckOut(datetime, labId1.current);
    };

    const[departmentCheckIn, setDepartmentCheckIn] = useState("");
    const[departmentCheckOut, setDepartmentCheckOut] = useState("");
    const[securityCheckIn,setSecurityCheckIn] = useState("");
    const[securityCheckOut, setSecurityCheckOut] = useState("");
    const[statusCount, setStatusCount] = useState(0);

    const statusCheck = () => {
        if(securityCheckOut === true){
            setStatusCount(4);
            return;
        }
        else if(departmentCheckOut === true){
            setStatusCount(3);
            return;

        }
        else if(departmentCheckIn === true){
            setStatusCount(2);
            return;

        }
        else if(securityCheckIn === true){
            setStatusCount(1);
            return;

        }
        else{
            setStatusCount(0);
            return;

        }
    };

    const stepStyleConfig = {
        activeBgColor: '#5dbbff',
        activeTextColor: '#000000',
        completedBgColor: '#32CD32',
        completedTextColor: '#000000',
        inactiveTextColor : '#000000',
    };

    const [vendorMasterData, setVendorMasterData] = useState([]);
    const [detailsForSecurityVendorId, setDetailsForSecurityVendorId] = useState([]);
    const [detailsForSecurityByShiftId, setDetailsForSecurityByShiftId] = useState([]);
    const [masterLabourerDetailsByTransactionDate, setMasterLabourerDetailsByTransactionDate,] = useState([{
        labourerName: <Skeleton/>
    }, {labourerName: <Skeleton/>}, {labourerName: <Skeleton/>}, {labourerName: <Skeleton/>}, {
        labourerName: <Skeleton/>
    }, {labourerName: <Skeleton/>},]);
    //const [securityTransactionDetailsByTransactionDate, setSecurityTransactionDetailsByTransactionDate] = useState([]);
    const [deptTransactionDetailsByTransactionDate, setDeptTransactionDetailsByTransactionDate,] = useState([{}]);
    const [checkCheckIn, setCheckCheckIn] = useState([{}]);
    const [deptCheckIn, setDeptCheckIn] = useState([]);
    const [deptCheckOut, setDeptCheckOut] = useState([]);
    const [entryType, setEntryType] = useState("");
    const [shiftId, setShiftId] = useState("");
    const [shiftName, setShiftName] = useState("");
    const [newArray, setNewArray] = useState([]);
    const [checkIn, setCheckIn] = useState(<Skeleton />);
    const [checkOut, setCheckOut] = useState("");
    const [shiftData, setShiftData] = useState([]);
    const [laborerId, setLaborerId] = useState("");
    const [laborerName, setLaborerName] = useState("");
    const [vendorId, setVendorId] = useState("");
    const [vendorName, setVendorName] = useState("");
    // const [vendorTransactionMaster, setVendorTransactionMaster] = useState([]);
    // const [vendorTransactionDetails, setVendorTransactionDetails] = useState([]);
    const [departmentCheckAdd, setSecurityCheckAdd] = useState([]);
    const FilterArray = useRef([]);
    const shiftIDRef = useRef("");

    const [showDCheckIn, setShowDCheckIn] = useState(false);
    const [showDCheckOut, setShowDCheckOut] = useState(false);
    const [role, setRole] = useState(localStorage.getItem("role"));
    const [showSubDeptDrop, setShowSubDeptDrop] = useState(false);
    const [subDeptDrop, setSubDeptDrop] = useState([]);
    const [subDeptUpdated, setSubDeptUpdated] = useState(false);
    const [editingLabourId, setEditingLabourId] = useState(null);
    const [tempSubDeptId, setTempSubDeptId] = useState("");
    const [tempSubDeptName, setTempSubDeptName] = useState("");
    const [labourerSubDeptAssignments, setLabourerSubDeptAssignments] = useState({});
    // Add new state for multiple selection
    const [selectedLabourers, setSelectedLabourers] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [selectedLabourersCheckOut, setSelectedLabourersCheckOut] = useState([]);
    const [selectAllCheckOut, setSelectAllCheckOut] = useState(false);
    // Add state for checkout labourers
    const [checkOutLabourers, setCheckOutLabourers] = useState([]);
    const [checkOutLabourersByShift, setCheckOutLabourersByShift] = useState([]);
    // const [counterDIn, setCounterDIn] = useState(0);
    // const [counterDOut, setCounterDOut] = useState(0);

    // Add loading states for buttons
    const [isBulkCheckInLoading, setIsBulkCheckInLoading] = useState(false);
    const [isBulkCheckOutLoading, setIsBulkCheckOutLoading] = useState(false);
    const [isIndividualCheckInLoading, setIsIndividualCheckInLoading] = useState(false);
    const [isIndividualCheckOutLoading, setIsIndividualCheckOutLoading] = useState(false);

    useEffect(() => {
        AOS.init();
        //      getVendorMasterDetails();
        const branchId = localStorage.getItem("branchId");
        //getMasterLabourerDetailsByTransactionDateAndBranchId(branchId);
        //getSecurityTransactionDetailsByTransactionDate();
        getDeptTransactionDetailsByTransactionDate(branchId);
        getShiftDetails();
        getLabourersForCheckOut(branchId);
    }, []);

    useEffect(() => {
        //

        //const checkInCount = securityTransactionDetailsByTransactionDate.filter(data => data.entryType == 'CheckIn' );
        //const checkOutCount = securityTransactionDetailsByTransactionDate.filter(data => data.entryType == 'CheckOut');
        // const checkInCount = deptTransactionDetailsByTransactionDate.filter((data) => data.entryType == "CheckIn");
        // const checkOutCount = deptTransactionDetailsByTransactionDate.filter((data) => data.entryType == "CheckOut");
        // setCheckIn(checkInCount.length);
        // setCheckOut(checkOutCount.length);
        // const counterDIn = checkInCount.length;
        // const counterDOut = checkOutCount.length;
        // setCheckIn(deptTransactionDetailsByTransactionDate[0].checkinCount);
        // setCounterDIn(deptTransactionDetailsByTransactionDate[0].checkinCount);
        // setCheckOut(deptTransactionDetailsByTransactionDate[0].checkoutcount);
        // setCounterDOut(deptTransactionDetailsByTransactionDate[0].checkoutcount);

        // Reset select all states when labour list changes
        setSelectAll(false);
        setSelectAllCheckOut(false);
        setSelectedLabourers([]);
        setSelectedLabourersCheckOut([]);
    }, [masterLabourerDetailsByTransactionDate, newArray, deptTransactionDetailsByTransactionDate, dataListNew,]);
    useEffect(() => {
    }, [transactionDate, checkCheckIn, deptCheckIn, deptCheckOut,]);
    useEffect(() => {
        //
    }, [laborerId, checkIn]);

    useEffect(()=>{
        // statusCheck();
    },[departmentCheckIn,departmentCheckOut,securityCheckIn,securityCheckOut,statusCount]);

    const getShiftDetails = () => {
        axios
            .get("getShiftDetails")
            .then((data) => {
                if (data.status === 200) {
                    const shiftData1 = data.data;
                    setShiftData(shiftData1);
                } else {
                }
            })
            .catch((error) => {
                // console.error(error);
            });
    };


    const getSubDepartmentDetailsbyDeptID = (deptId) => {
        setSubDeptDrop([]);
        axios
            .get("getSubDepartmentDetailsbyDeptID/" + deptId)
            .then((data) => {
                if (data.status === 200) {
                    const newData = data.data;
                    setSubDeptDrop(newData);
                } else {
                    // window.location.href = "/error"
                }
            })
            .catch((error) => {
                console.error(error);
                // window.location.href = "/error"
            });
    };


    const editLabourSubD = (e) => {
        e.preventDefault();
        console.log(e.target.value);
        console.log(e.target.selectedOptions[0].id);
        setTempSubDeptId(e.target.value);
        setTempSubDeptName(e.target.selectedOptions[0].id);
        setSubDeptUpdated(true);
    }

    const handleSubDeptEditClick = (labourId) => {
        setEditingLabourId(labourId);
        setShowSubDeptDrop(!showSubDeptDrop);
        // Load subdepartments for the current department when edit is clicked
        if (dataListNew.deptId) {
            getSubDepartmentDetailsbyDeptID(dataListNew.deptId);
        }
        // Reset temp values
        setTempSubDeptId(dataListNew.subDeptId || "");
        setTempSubDeptName(dataListNew.subDeptName || "");
    }

    const saveLabourSubD = (e) => {
        // Save the subdepartment assignment for this specific labourer
        const labourId = dataListNew.labourId;
        setLabourerSubDeptAssignments(prev => ({
            ...prev,
            [labourId]: {
                subDeptId: tempSubDeptId,
                subDeptName: tempSubDeptName
            }
        }));

        // Update the current display
        setDataListNew({...dataListNew,
            subDeptId : tempSubDeptId,
            subDeptName : tempSubDeptName
        });

        setShowSubDeptDrop(false);
        setSubDeptUpdated(true);
        setEditingLabourId(null);
        // Update the global state as well
        setSubDeptId(tempSubDeptId);
        setSubDeptName(tempSubDeptName);

        toast.success("Subdepartment assignment saved for this labourer");
    }

    // Function to clear all subdepartment assignments
    const clearAllSubDeptAssignments = () => {
        setLabourerSubDeptAssignments({});
        toast.info("All subdepartment assignments cleared");
    }

    // Validation function to check if subdepartment assignment is valid
    const validateSubDepartmentAssignment = (labourer) => {
        // Check if subdepartment is assigned and not empty
        return labourer.subDeptId && labourer.subDeptId !== '';
    }

    const getVendorMasterDetails = () => {
        axios
            .get("getVendorMasterDetails")
            .then((data) => {
                if (data.status === 200) {
                    const vendorMasterData = data.data;
                    setVendorMasterData(vendorMasterData);
                } else {
                    // window.location.href = "/error"
                }
            })
            .catch((error) => {
                console.error(error);

                // window.location.href = "/error"
            });
    };

    const getMasterLabourerDetailsByTransactionDateAndBranchId = (branchId) => {
        var currentdate = new Date();
        // var transactionDate = '2023-02-23 00:00:00';
        var transactionDate = formatDate(currentdate);
        console.log("Calling API with transactionDate:", transactionDate);
        axios
            .get("getLabourersSecurityCheckedInButNotDeptCheckedIn/" + transactionDate + "/" + branchId)
            .then((data) => {
                if (data.status === 200) {
                    const getData = data.data;
                    console.log("API response:", getData);
                    setMasterLabourerDetailsByTransactionDate(getData);
                } else {
                    console.error("API returned non-200 status:", data.status);
                }
            })
            .catch((error) => {
                console.error("API call failed:", error);
                console.error("Error details:", error.response?.data);
                setMasterLabourerDetailsByTransactionDate([]);
            });
    };


    const getMasterLabourerDetailsByTransactionDateAndBranchIdAndDeptId = (branchId, departmentId) => {
        var currentdate = new Date();
        var transactionDate = formatDate(currentdate);
        axios
            .get("getMasterLabourerDetailsByTransactionDateAndBranchIdAndDeptId/" + transactionDate + "/" + branchId + "/" + departmentId)
            .then((data) => {
                if (data.status === 200) {
                    const getData = data.data;
                    // console.log(getData);
                    setMasterLabourerDetailsByTransactionDate(getData);
                } else {
                }
            })
            .catch((error) => {
                // console.error(error);
            });
    };

    const getDeptTransactionDetailsByTransactionDate = (branchId, departmentId1) => {
        //
        var currentdate = new Date();
        // var transactionDate = '2023-02-23 00:00:00';
        var transactionDate = formatDate(currentdate);
        axios
            .get("getDepartmentTransactionDetailsByTransactionDateAndBranchId/" + transactionDate + "/" + branchId)
            .then((data) => {
                if (data.status === 200) {
                    const getData = data.data;
                    setDeptTransactionDetailsByTransactionDate(getData);
                    setCheckIn(getData[0].checkinCount);
                    setCheckOut(getData[0].checkoutcount);
                } else {
                }
            })
            .catch((error) => {
                // console.error(error);
            });
        if(role === "Department"){
            const departmentId = localStorage.getItem("departmentId");
            if(departmentId !== null){
                getMasterLabourerDetailsByTransactionDateAndBranchIdAndDeptId(branchId,departmentId);
            }
            else{
                getMasterLabourerDetailsByTransactionDateAndBranchId(branchId);
            }
        }
        else{
            getMasterLabourerDetailsByTransactionDateAndBranchId(branchId);
        }
    };

    const getCheckInCheckOutDetails = (transactionDate, labourId) => {
        var currentdate = new Date();
        var transactionDate = formatDate(currentdate);
        axios
            .get("getCheckInCheckOutDetails/" + transactionDate + "/" + labourId)
            .then((data) => {
                if (data.status === 200) {
                    setSecurityCheckIn(data.data[0].securityCheckIn);
                    setSecurityCheckOut(data.data[0].securityCheckOut);
                    setDepartmentCheckIn(data.data[0].deptCheckIn);
                    setDepartmentCheckOut(data.data[0].deptCheckOut);
                } else {
                }
            })
            .catch((error) => {
                // console.error(error);
            });
    };

    const getCheckCheckIn = (transactionDate, labourId) => {
        var currentdate = new Date();
        // var transactionDate = '2023-02-23 00:00:00';
        var transactionDate = formatDate(currentdate);
        //                    labourId = labourId;
        axios
            .get("getSecurityTransactionDetailsCheckIn/CheckIn/" + transactionDate + "/" + labourId)
            .then((data) => {
                if (data.status === 200) {
                    setCheckCheckIn(data.data);
                } else {
                }
            })
            .catch((error) => {
                // console.error(error);
            });
    };
    const getDeptCheckIn = (transactionDate, labourId) => {
        var currentdate = new Date();
        // var transactionDate = '2023-02-23 00:00:00';
        var transactionDate = formatDate(currentdate);
        //                  labourId = labourId;
        axios
            .get("getDeptTransactionDetailsCheckOut/CheckIn/" + transactionDate + "/" + labourId)
            .then((data) => {
                if (data.status === 200) {
                    setDeptCheckIn(data.data);
                    if (data.data.length > 0) {
                        setShowDCheckIn(false);
                    } else {
                        setShowDCheckIn(true);
                    }
                } else {
                }
            })
            .catch((error) => {
                // console.error(error);
            });
    };
    const getDeptCheckOut = (transactionDate, labourId) => {
        var currentdate = new Date();
        // var transactionDate = '2023-02-23 00:00:00';
        var transactionDate = formatDate(currentdate);
        //                    labourId = labourId;
        axios
            .get("getDeptTransactionDetailsCheckOut/CheckOut/" + transactionDate + "/" + labourId)
            .then((data) => {
                if (data.status === 200) {
                    setDeptCheckOut(data.data);
                    if (data.data.length > 0) {
                        setShowDCheckOut(false);
                    } else {
                        setShowDCheckOut(true);
                    }
                } else {
                }
            })
            .catch((error) => {
                // console.error(error);
            });
    };
    const getDetailsForCheckInOutByVendorId = (vendorId) => {
        axios
            .get("getDetailsForCheckInOutByVendorId/" + vendorId)
            .then((data) => {
                if (data.status === 200) {
                    const getData = data.data;
                    setDetailsForSecurityVendorId(getData);
                } else {
                    // window.location.href = "/error"
                }
            })
            .catch((error) => {
                console.error(error);

                // window.location.href = "/error"
            });
    };

    const getEmpDetailsForCheckInOutByShiftId = (shiftId) => {
        axios
            .get("getEmpDetailsForCheckInOutByShiftId/" + shiftId)
            .then((data) => {
                if (data.status === 200) {
                    const getData2 = data.data;
                    setDetailsForSecurityByShiftId(getData2);
                } else {
                }
            })
            .catch((error) => {
                // console.error(error);
            });
    };

    const onSelectVendor = (e) => {
        setVendorId(e.target.value);
        getDetailsForCheckInOutByVendorId(e.target.value);
    };

    const onSelectShift = (e) => {
        if (e.target.value == "") {
            setShowEmpDetails(false);
            setNewArray([]);
            setCheckOutLabourersByShift([]);
            return;
        }
        setShowEmpDetails(false);
        setShiftId(e.target.value);
        shiftIDRef.current = e.target.value;

        var currentdate = new Date();
        var transactionDate = formatDate(currentdate);
        const branchId = localStorage.getItem("branchId");

        // Get labourers for check-in
        axios
            .get("getLabourersSecurityCheckedInButNotDeptCheckedInByShift/" + transactionDate + "/" + branchId + "/" + e.target.value)
            .then((data) => {
                if (data.status === 200) {
                    const getData = data.data;
                    setNewArray(getData);
                } else {
                    setNewArray([]);
                }
            })
            .catch((error) => {
                console.error(error);
                setNewArray([]);
            });

        // Get labourers for check-out
        getLabourersForCheckOutByShift(branchId, e.target.value);
    };

    // Add new functions for multiple selection
    const handleSelectAll = (e) => {
        const isChecked = e.target.checked;
        setSelectAll(isChecked);

        if (isChecked) {
            const currentLabourers = shiftIDRef.current === ""
                ? masterLabourerDetailsByTransactionDate
                : newArray;
            setSelectedLabourers(currentLabourers.map(lab => lab.labourId));
        } else {
            setSelectedLabourers([]);
        }
    };

    const handleSelectAllCheckOut = (e) => {
        const isChecked = e.target.checked;
        setSelectAllCheckOut(isChecked);

        if (isChecked) {
            const currentLabourers = shiftIDRef.current === ""
                ? checkOutLabourers
                : checkOutLabourersByShift;
            setSelectedLabourersCheckOut(currentLabourers.map(lab => lab.labourId));
        } else {
            setSelectedLabourersCheckOut([]);
        }
    };

    const handleSelectLabourer = (labourId) => {
        setSelectedLabourers(prev => {
            if (prev.includes(labourId)) {
                return prev.filter(id => id !== labourId);
            } else {
                return [...prev, labourId];
            }
        });
    };

    const handleSelectLabourerCheckOut = (labourId) => {
        setSelectedLabourersCheckOut(prev => {
            if (prev.includes(labourId)) {
                return prev.filter(id => id !== labourId);
            } else {
                return [...prev, labourId];
            }
        });
    };

    const handleBulkCheckIn = async (e) => {
        e.preventDefault();
        if (selectedLabourers.length === 0) {
            toast.warning("Please select at least one labourer");
            return;
        }

        if (isBulkCheckInLoading) return; // Prevent multiple clicks

        // Validate that all selected labourers have proper department assignments
        const currentLabourers = shiftIDRef.current === ""
            ? masterLabourerDetailsByTransactionDate
            : newArray;

        const invalidLabourers = selectedLabourers.filter(labourId => {
            const labourer = currentLabourers.find(lab => lab.labourId === labourId);
            if (!labourer) return true;

            // Check if this labourer has a saved subdepartment assignment
            const savedAssignment = labourerSubDeptAssignments[labourId];
            const subDeptId = savedAssignment ? savedAssignment.subDeptId : labourer.subDeptId;

            return !subDeptId || subDeptId === '';
        });

        if (invalidLabourers.length > 0) {
            toast.error("Some selected labourers have invalid subdepartment assignments. Please ensure all labourers have subdepartment assigned.");
            return;
        }

        setIsBulkCheckInLoading(true);
        const userName = localStorage.getItem("username");
        const promises = selectedLabourers.map(labourId => {
            const labourer = (shiftIDRef.current === ""
                ? masterLabourerDetailsByTransactionDate
                : newArray).find(lab => lab.labourId === labourId);

            if (!labourer) return Promise.resolve();

            // Check if this labourer has a saved subdepartment assignment
            const savedAssignment = labourerSubDeptAssignments[labourId];
            const subDeptId = savedAssignment ? savedAssignment.subDeptId : labourer.subDeptId;
            const subDeptName = savedAssignment ? savedAssignment.subDeptName : labourer.subDeptName;

            var currentdate = new Date();
            var datetime = formatDate(currentdate);
            var datetime1 = formatDateTime(currentdate);

            const deptVendorDataAdd1 = {
                vendorId: labourer.vendorId,
                vendorCLTransactionId: labourer.clTransactionId,
                transactionDate: datetime,
                subDepartmentId: subDeptId,
                departmentId: labourer.deptId,
                labourId: labourId,
                entryType: "CheckIn",
                shiftId: labourer.shiftId,
                shiftName: labourer.shiftName,
                createdBy: userName,
                createdDate: datetime1,
                branchId: labourer.branchId,
            };

            return axios.post("addDeptTransactionDetails", deptVendorDataAdd1);
        });

        try {
            await Promise.all(promises);
            setShowDepMsgI(true);
            setCheckIn(checkIn + selectedLabourers.length);
            setSelectedLabourers([]);
            setSelectAll(false);
            // Refresh the data
            const branchId = localStorage.getItem("branchId");
            getDeptTransactionDetailsByTransactionDate(branchId);
            getLabourersForCheckOut(branchId); // Refresh checkout data
            if (shiftIDRef.current !== "") {
                getLabourersForCheckOutByShift(branchId, shiftIDRef.current); // Refresh checkout data by shift
            }
            toast.success(`Successfully checked in ${selectedLabourers.length} labourer(s)`);
            handleShow(e);
        } catch (error) {
            console.error("Bulk check-in failed:", error);
            toast.error("Some check-ins failed. Please try again.");
        } finally {
            setIsBulkCheckInLoading(false);
        }
    };

    const handleBulkCheckOut = async (e) => {
        e.preventDefault();
        if (selectedLabourersCheckOut.length === 0) {
            toast.warning("Please select at least one labourer");
            return;
        }

        if (isBulkCheckOutLoading) return; // Prevent multiple clicks

        setIsBulkCheckOutLoading(true);
        const userName = localStorage.getItem("username");
        const promises = selectedLabourersCheckOut.map(labourId => {
            const labourer = (shiftIDRef.current === ""
                ? checkOutLabourers
                : checkOutLabourersByShift).find(lab => lab.labourId === labourId);

            if (!labourer) return Promise.resolve();

            var currentdate = new Date();
            var datetime = formatDate(currentdate);
            var datetime1 = formatDateTime(currentdate);

            const deptVendorDataAdd2 = {
                vendorId: labourer.vendorId,
                vendorCLTransactionId: labourer.clTransactionId,
                transactionDate: datetime,
                subDepartmentId: labourer.subDeptId,
                departmentId: labourer.deptId,
                labourId: labourId,
                entryType: "CheckOut",
                shiftId: labourer.shiftId,
                shiftName: labourer.shiftName,
                createdBy: userName,
                createdDate: datetime1,
                branchId: labourer.branchId,
            };

            return axios.post("addDeptTransactionDetails", deptVendorDataAdd2);
        });

        try {
            await Promise.all(promises);
            setShowDepMsgO(true);
            setCheckOut(checkOut + selectedLabourersCheckOut.length);
            setSelectedLabourersCheckOut([]);
            setSelectAllCheckOut(false);
            // Refresh the data
            const branchId = localStorage.getItem("branchId");
            getDeptTransactionDetailsByTransactionDate(branchId);
            getLabourersForCheckOut(branchId); // Refresh checkout data
            if (shiftIDRef.current !== "") {
                getLabourersForCheckOutByShift(branchId, shiftIDRef.current); // Refresh checkout data by shift
            }
            toast.success(`Successfully checked out ${selectedLabourersCheckOut.length} labourer(s)`);
            checkOutBtn(e);
        } catch (error) {
            console.error("Bulk check-out failed:", error);
            toast.error("Some check-outs failed. Please try again.");
        } finally {
            setIsBulkCheckOutLoading(false);
        }
    };

    const userName = localStorage.getItem("username");
    const handleSubmitCheckIn = async (e) => {
        e.preventDefault();

        if (isIndividualCheckInLoading) return; // Prevent multiple clicks

        // Validate subdepartment assignment
        const savedAssignment = labourerSubDeptAssignments[dataListNew.labourId];
        const subDeptId = savedAssignment ? savedAssignment.subDeptId : dataListNew.subDeptId;

        if (!subDeptId || subDeptId === '') {
            toast.error("Please select subdepartment before checking in.");
            return;
        }

        setIsIndividualCheckInLoading(true);
        var currentdate = new Date();
        var datetime = formatDate(currentdate);
        var datetime1 = formatDateTime(currentdate);
        const deptVendorDataAdd1 = {
            //transactionId: transactionId,
            vendorId: vendorId, // vendorName: vendorName,
            vendorCLTransactionId: clTransactionId,
            transactionDate: datetime,
            subDepartmentId: subDeptId,
            departmentId: deptId,
            labourId: labId1.current, // labourName: laborerName,
            entryType: "CheckIn",
            shiftId: shiftId,
            shiftName: shiftName,
            createdBy: userName,
            createdDate: datetime1, // departmentName: deptName,
            // subDepartmentName: subDeptName,
            branchId: branchId,
        };

        try {
            const response = await axios.post("addDeptTransactionDetails", deptVendorDataAdd1);
            if (response.status === 200) {
                setShowDepMsgI(true);
                setDeptCheckIn([...deptCheckIn, response]);
                setDepartmentCheckIn(true);
                setCheckIn(checkIn + 1);
                // Refresh the data
                const branchId = localStorage.getItem("branchId");
                getDeptTransactionDetailsByTransactionDate(branchId);
                getLabourersForCheckOut(branchId); // Refresh checkout data
                if (shiftIDRef.current !== "") {
                    getLabourersForCheckOutByShift(branchId, shiftIDRef.current); // Refresh checkout data by shift
                }
                toast.success("Successfully checked in labourer");
                //departmentCheckAdd.TransactionId = data.data.TransactionId;
                //setSecurityCheckAdd(departmentCheckAdd);
            }
        } catch (error) {
            console.error(error);
            toast.error("Check-in failed. Please try again.");
        }

        if(subDeptUpdated === true){
            try {
                await axios.put("updateVendorCLDetails", dataListNew);
            } catch (error) {
                console.error(error);
            }
        }

        setIsIndividualCheckInLoading(false);
    };

    const handleSubmitCheckOut = async (e) => {
        e.preventDefault();

        if (isIndividualCheckOutLoading) return; // Prevent multiple clicks

        setIsIndividualCheckOutLoading(true);
        var currentdate = new Date();
        var datetime = formatDate(currentdate);
        var datetime1 = formatDateTime(currentdate);
        const deptVendorDataAdd2 = {
            //transactionId: transactionId,
            vendorId: vendorId, vendorCLTransactionId: clTransactionId, // vendorName: vendorName,
            transactionDate: datetime, subDepartmentId: subDeptId, departmentId: deptId, labourId: labId1.current, // labourName: laborerName,
            entryType: "CheckOut", shiftId: shiftId, shiftName: shiftName, createdBy: userName, createdDate: datetime1, // departmentName: deptName,
            // subDepartmentName: subDeptName,
            branchId: branchId,
        };

        try {
            const response = await axios.post("addDeptTransactionDetails", deptVendorDataAdd2);
            if (response.status === 200) {
                setShowDepMsgO(true);
                setDeptCheckOut([...deptCheckOut, response]);
                setDepartmentCheckOut(true);
                setCheckOut(checkOut + 1);
                // Refresh the data
                const branchId = localStorage.getItem("branchId");
                getDeptTransactionDetailsByTransactionDate(branchId);
                getLabourersForCheckOut(branchId); // Refresh checkout data
                if (shiftIDRef.current !== "") {
                    getLabourersForCheckOutByShift(branchId, shiftIDRef.current); // Refresh checkout data by shift
                }
                toast.success("Successfully checked out labourer");
                //departmentCheckAdd.TransactionId = data.data.TransactionId;
                //setSecurityCheckAdd(departmentCheckAdd);
            }
        } catch (error) {
            console.error(error);
            toast.error("Check-out failed. Please try again.");
        } finally {
            setIsIndividualCheckOutLoading(false);
        }
    };

    // Function to get labourers who are checked in but not checked out
    const getLabourersForCheckOut = (branchId) => {
        var currentdate = new Date();
        var transactionDate = formatDate(currentdate);
        axios
            .get("getLabourersDeptCheckedInButNotCheckedOut/" + transactionDate + "/" + branchId)
            .then((data) => {
                if (data.status === 200) {
                    const getData = data.data;
                    setCheckOutLabourers(getData);
                } else {
                    setCheckOutLabourers([]);
                }
            })
            .catch((error) => {
                console.error(error);
                setCheckOutLabourers([]);
            });
    };

    // Function to get labourers for checkout by shift
    const getLabourersForCheckOutByShift = (branchId, shiftId) => {
        var currentdate = new Date();
        var transactionDate = formatDate(currentdate);
        axios
            .get("getLabourersDeptCheckedInButNotCheckedOutByShift/" + transactionDate + "/" + branchId + "/" + shiftId)
            .then((data) => {
                if (data.status === 200) {
                    const getData = data.data;
                    setCheckOutLabourersByShift(getData);
                } else {
                    setCheckOutLabourersByShift([]);
                }
            })
            .catch((error) => {
                console.error(error);
                setCheckOutLabourersByShift([]);
            });
    };

    // Helper function to render labour list with checkboxes for Check In
    const renderLabourListCheckIn = (labourList) => (
        <Card className="CardScroll">
            <div className="bulk-actions mb-2 p-2" style={{
                backgroundColor: '#f8f9fa',
                borderBottom: '1px solid #dee2e6',
                borderRadius: '4px 4px 0 0'
            }}>
                <div className="d-flex justify-content-between align-items-center">
                    <Form.Check
                        type="checkbox"
                        label={<strong>Select All ({labourList.length})</strong>}
                        checked={selectAll}
                        onChange={handleSelectAll}
                    />
                    {selectedLabourers.length > 0 && (
                        <span className="badge bg-primary">{selectedLabourers.length} selected</span>
                    )}
                </div>
                {selectedLabourers.length > 0 && (
                    <div className="mt-2">
                        <Button
                            size="sm"
                            variant="success"
                            onClick={handleBulkCheckIn}
                            className="me-2"
                            disabled={isBulkCheckInLoading}
                        >
                            <FiLogIn className="me-1" />
                            {isBulkCheckInLoading ? "Processing..." : `Bulk Check In (${selectedLabourers.length})`}
                        </Button>
                    </div>
                )}
            </div>
            <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                {labourList.map((dataList) => (
                    <Row key={dataList.labourId} className="mt-2 align-items-center p-2" style={{
                        backgroundColor: selectedLabourers.includes(dataList.labourId) ? '#e8f5e8' : 'transparent',
                        borderBottom: '1px solid #f0f0f0',
                        transition: 'background-color 0.2s'
                    }}>
                        <Col xs={2}>
                            <Form.Check
                                type="checkbox"
                                checked={selectedLabourers.includes(dataList.labourId)}
                                onChange={() => handleSelectLabourer(dataList.labourId)}
                            />
                        </Col>
                        <Col xs={10}>
                            <p
                                className="info1 mb-0"
                                onClick={(e) => onClickEmpName(dataList)}
                                style={{ cursor: 'pointer', transition: 'background-color 0.2s' }}
                                onMouseEnter={(e) => e.target.style.backgroundColor = '#e9ecef'}
                                onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                            >
                                {dataList.labourerName}
                            </p>
                        </Col>
                    </Row>
                ))}
            </div>
        </Card>
    );

    // Helper function to render labour list with checkboxes for Check Out
    const renderLabourListCheckOut = (labourList) => (
        <Card className="CardScroll">
            <div className="bulk-actions mb-2 p-2" style={{
                backgroundColor: '#f8f9fa',
                borderBottom: '1px solid #dee2e6',
                borderRadius: '4px 4px 0 0'
            }}>
                <div className="d-flex justify-content-between align-items-center">
                    <Form.Check
                        type="checkbox"
                        label={<strong>Select All ({labourList.length})</strong>}
                        checked={selectAllCheckOut}
                        onChange={handleSelectAllCheckOut}
                    />
                    {selectedLabourersCheckOut.length > 0 && (
                        <span className="badge bg-warning text-dark">{selectedLabourersCheckOut.length} selected</span>
                    )}
                </div>
                {selectedLabourersCheckOut.length > 0 && (
                    <div className="mt-2">
                        <Button
                            size="sm"
                            variant="warning"
                            onClick={handleBulkCheckOut}
                            disabled={isBulkCheckOutLoading}
                        >
                            <FiLogOut className="me-1" />
                            {isBulkCheckOutLoading ? "Processing..." : `Bulk Check Out (${selectedLabourersCheckOut.length})`}
                        </Button>
                    </div>
                )}
            </div>
            <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                {labourList.map((dataList) => (
                    <Row key={dataList.labourId} className="mt-2 align-items-center p-2" style={{
                        backgroundColor: selectedLabourersCheckOut.includes(dataList.labourId) ? '#fff3cd' : 'transparent',
                        borderBottom: '1px solid #f0f0f0',
                        transition: 'background-color 0.2s'
                    }}>
                        <Col xs={2}>
                            <Form.Check
                                type="checkbox"
                                checked={selectedLabourersCheckOut.includes(dataList.labourId)}
                                onChange={() => handleSelectLabourerCheckOut(dataList.labourId)}
                            />
                        </Col>
                        <Col xs={10}>
                            <p
                                className="info1 mb-0"
                                onClick={(e) => onClickEmpName(dataList)}
                                style={{ cursor: 'pointer', transition: 'background-color 0.2s' }}
                                onMouseEnter={(e) => e.target.style.backgroundColor = '#e9ecef'}
                                onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                            >
                                {dataList.labourerName}
                            </p>
                        </Col>
                    </Row>
                ))}
            </div>
        </Card>
    );

    let showEmployeeDetails;
    if (showEmpDetails) {
        let dataShift = shiftData.filter(key => key.shiftId === dataListNew.shiftId);
        let shiftNameAfterClick = dataShift[0]?.shiftName;
        showEmployeeDetails = (<Card className="CardInt">
            {//detailsForSecurityByShiftId.map(dataList => (
                <div>
                    <div className="employeeRow mt-3">
                        <Col md={{span: 6, offset: 6}} className="p-0 employeeImg">
                            <img src={dataListNew.labourImgUrl || user} className="userpic" alt=""/>
                        </Col>
                    </div>
                    <div>
                        {/* {
          labourerMasterDetails.map(empList => ( */}
                        <Col lg={10} className={"labourDetails"}>
                            <Row className="mt-3">
                                <label className="labelEmpDetStyl">Name :</label>
                                <p className="pEmpDetStyl">{dataListNew.labourerName}</p>
                            </Row>
                            <Row className="mt-1">
                                <label className="labelEmpDetStyl">Vendor :</label>
                                <p className="pEmpDetStyl">{dataListNew.vendorName}</p>
                            </Row>
                            <Row className="mt-1">
                                <label className="labelEmpDetStyl">Aadhaar No :</label>
                                <p className="pEmpDetStyl">{dataListNew.adhaarNo}</p>
                            </Row>
                            <Row className="mt-1">
                                <label className="labelEmpDetStyl">Shift :</label>
                                <p className="pEmpDetStyl">{shiftNameAfterClick}</p>
                            </Row>
                            <Row className="mt-1">
                                <label className="labelEmpDetStyl">Department :</label>
                                <p className="pEmpDetStyl">{dataListNew.deptName}</p>
                            </Row>
                            <Row className="mt-1 mb-3">
                                <div>
                                    <label className="labelEmpDetStyl">Sub-Department :</label>
                                    {departmentCheckIn === false && (<FontAwesomeIcon icon={faPen} className={"floatInlineEnd"} onClick={() => handleSubDeptEditClick(dataListNew.labourId)}/>)}
                                </div>
                                {showSubDeptDrop === true && editingLabourId === dataListNew.labourId && <Form.Select
                                    aria-label="Default select example"
                                    className="info1"
                                    onChange={(e) => editLabourSubD(e)}
                                    value={tempSubDeptId}
                                >
                                    <option value="">Select Subdepartment</option>
                                    {subDeptDrop.map((subDept) => (<option
                                        key={subDept.subDepartmentId}
                                        value={subDept.subDepartmentId}
                                        id={subDept.subDepartmentName}
                                    >
                                        {subDept.subDepartmentName}
                                    </option>))}
                                </Form.Select>}
                                {showSubDeptDrop === false &&<p className="pEmpDetStyl">{dataListNew.subDeptName}</p>}
                            </Row>
                            <div className=" mb-2 floatRight">
                                {showSubDeptDrop === true && editingLabourId === dataListNew.labourId &&
                                    <Button className={"btn btn-primary securitySubmit"} type="submit" onClick={(e) => saveLabourSubD(e)} disabled={!subDeptUpdated}>Submit</Button>
                                }
                            </div>
                        </Col>
                    </div>
                </div>}
            {/*           ))} */}
        </Card>);
    }

    return (<div>
        <Container fluid className="px-0">
            <div className="mt-1 mb-2">
                <h5 className="priColor mb-0">Department</h5>
            </div>
            <div data-aos="zoom-in-right" data-aos-duration="550">
                <Card className="cardStyl">
                        <div>
                            <Row>
                                <Col
                                    className="badgeClass1"
                                    md={6}
                                    sm={6}
                                    xs={6}
                                    xl={6}
                                    lg={6}
                                >
                                    <Card className="counter-block">
                                        <Row>
                                            <Col md={4} sm={12} xl={4} lg={4}>
                                                <FiLogIn className="icon-dim"/>
                                            </Col>
                                            <Col md={8} sm={12} xl={8} lg={8}>
                                                {/*                                 <div class="col-lg-6 col-md-6"> */}
                                                {/* <i class="FiLogIn"></i> */}
                                                <p className="counter-block-p">
                                                    No. Of Labourers Checked-In
                                                </p>
                                                {/*                                     <p></p> */}
                                                <p className="count-p">{checkIn}</p>

                                                {/*                                 </div> */}
                                            </Col>
                                        </Row>
                                    </Card>
                                </Col>
                                <Col
                                    className="badgeClass2"
                                    md={6}
                                    sm={6}
                                    xs={6}
                                    xl={6}
                                    lg={6}
                                >
                                    <Card className="counter-block">
                                        <Row>
                                            <Col md={4} sm={12} xl={4} lg={4}>
                                                <FiLogOut className="icon-dim"/>
                                            </Col>
                                            <Col md={8} sm={12} xl={8} lg={8}>
                                                {/*                                 <div class="col-lg-6 col-md-6"> */}
                                                {/* <i class="FiLogIn"></i> */}
                                                <p className="counter-block-p">
                                                    No. Of Labourers Checked-Out
                                                </p>
                                                {/*                                           <p></p> */}
                                                <p className="count-p">{checkOut}</p>
                                                {/*                                 </div> */}
                                            </Col>
                                        </Row>
                                    </Card>
                                </Col>
                            </Row>
                        </div>

                        {/* //           <Card className='cardStyl'> */}
                        {/*             <div> */}
                        {/*               <Row className=''> */}
                        {/*                 <Col md={4} sm={12} xl={4} lg={4} className='displayflex'> */}
                        {/*                   <Form.Select */}
                        {/*                     onChange={e => onSelectVendor(e)} */}
                        {/*                   // value={vendorMasterData} */}
                        {/*                   > */}
                        {/*                     <option value="">Select Vendor</option> */}
                        {/*                     { */}
                        {/*                       vendorMasterData.map(vendor => ( */}
                        {/*                         <option key={vendor.id} value={vendor.id}> */}
                        {/*                           {vendor.vendorName} */}
                        {/*                         </option> */}
                        {/*                       ))} */}
                        {/*                   </Form.Select> */}
                        {/*                 </Col> */}
                        {/*                  */}
                        {/* <Col md={4} sm={12} xl={4} lg={4} className='displayflex'> */}
                        {/*                         <Form.Select aria-label="Default select example" */}
                        {/*                           {...register("vendor", { required: true })}> */}
                        {/*                           <option>Vendor List</option> */}
                        {/*                           <option value="1">One</option> */}
                        {/*                           <option value="2">Two</option> */}
                        {/*                           <option value="3">Three</option> */}
                        {/*                         </Form.Select> */}
                        {/*                         {errors.vendor && <p className='validationMsg'>Vendor is Required</p>} */}
                        {/*                         <span>&nbsp;&nbsp;&nbsp;&nbsp;(Or)</span> */}
                        {/*                       </Col> */}

                        {/*                 <Col md={3} sm={3} xl={3} lg={3}> */}
                        {/*                   <Row> */}
                        {/*                     <Col> */}
                        {/*                       <Form.Control type="text" placeholder="Search by Emp Id or Mob no" /> */}
                        {/*                     </Col> */}
                        {/*                   </Row> */}
                        {/*                 </Col> */}
                        {/*                  */}
                        {/* <Col lg={2}> */}
                        {/*                   <Col md={2} sm={2} xl={2} lg={2}> */}

                        {/*                     <Button className='btnwidth btnShadow' variant="light"> */}
                        {/*                       <IoIosAdd /> Add Filter */}
                        {/*                     </Button> */}
                        {/*                   </Col> */}
                        {/*                   <Col md={2} sm={2} xl={2} lg={2}> */}
                        {/*                   </Col> */}
                        {/*                 <Col lg={2}> */}
                        {/*                   <Button className='btnwidth btnShadow'>Search</Button> */}
                        {/*                 </Col> */}
                        {/*               </Row> */}
                        {/*             </div> */}
                        <div>
                            <Card className=" cardCheckin1">
                                <Row className="m-2">
                                    {/* <div>
                                    <Stepper
                                    steps=
                                    {[
                                            { label: 'Security In'},
                                            { label: 'Department In' },
                                            { label: 'Department Out' },
                                            { label: 'Security Out'}
                                    ]}
                                    activeStep={statusCount}
                                    styleConfig={stepStyleConfig}
                                    />
                                </div> */}
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Form>
                                            <div>
                                                <h6>Check In</h6>
                                            </div>
                                            <Card>
                                                <Row className=" m-3">
                                                    <Col lg={12} md={12} sm={12} xs={12}>
                                                        <Row>
                                                            <Col md={6} sm={12} xl={6} lg={6}>
                                                                <Row>
                                                                    <Form.Select
                                                                        aria-label="Default select example"
                                                                        className="info1"
                                                                        onChange={(e) => onSelectShift(e)}
                                                                        // value={shiftId}
                                                                        // value={detailsForSecurityVendorId}
                                                                        // {...register("shift", { required: true })}
                                                                    >
                                                                        <option value="">Select Shift</option>
                                                                        {shiftData.map((shift) => (<option
                                                                            key={shift.shiftId}
                                                                            value={shift.shiftId}
                                                                        >
                                                                            {shift.shiftName}
                                                                        </option>))}
                                                                        {/*                                       // <option value="2">Vendor-2</option> */}
                                                                        {/*                                       // <option value="3">Vendor-3</option> */}
                                                                        {/*                                     ))} */}
                                                                    </Form.Select>
                                                                    {/* {errors.shift && <p className='validationMsg'>Shift is Required</p>} */}
                                                                </Row>
                                                                <Row className=" mt-3">
                                                                    <Form.Control
                                                                        type="text"
                                                                        className="info1"
                                                                        placeholder="Select Emp"
                                                                        {...register("selectempci", {
                                                                            required: true,
                                                                        })}
                                                                    />
                                                                </Row>
                                                                <Row>
                                                                    {shiftIDRef.current == "" && renderLabourListCheckIn(masterLabourerDetailsByTransactionDate)}
                                                                    {errors.selectempci && (
                                                                        <p className="validationMsg">
                                                                            Selecting employee is Required
                                                                        </p>)}
                                                                </Row>
                                                                <Row>
                                                                    {shiftIDRef.current != "" && renderLabourListCheckIn(newArray)}
                                                                    {errors.selectempci && (
                                                                        <p className="validationMsg">
                                                                            Selecting employee is Required
                                                                        </p>)}
                                                                </Row>
                                                            </Col>

                                                            <Col
                                                                className={"employeeCard"}
                                                                md={6}
                                                                sm={12}
                                                                xl={6}
                                                                lg={6}
                                                            >
                                                                {showEmployeeDetails}
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>

                                                <Row>
                                                    <div className="buttonProceedDiv">
                                                        <div className="container">
                                                            <div className="row p-0">
                                                                <div className="text-left p-0">
                                                                    {/*                                 {checkCheckIn.length} */}
                                                                    {/*                                 {deptCheckIn.length} */}
                                                                    {securityCheckIn === true && departmentCheckIn === false && (
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-success float-end mx-2"
                                                                            onClick={(e) => handleShow(e)}
                                                                            disabled={isIndividualCheckInLoading}
                                                                        >
                                                                            {isIndividualCheckInLoading ? "Processing..." : "Check In"}
                                                                        </button>)}
                                                                    {securityCheckIn === false && (
                                                                        <p className="error-msg-p">
                                                                            Labour's Security Check-In pending.
                                                                        </p>)}
                                                                    {departmentCheckIn === true && (
                                                                        <p className="error-msg-p">
                                                                            Labour already Checked-In.
                                                                        </p>)}
                                                                    {/* <button type="button" className="btn btn-reject float-end">Check In</button> */}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Row>
                                            </Card>
                                        </Form>
                                    </Col>

                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        {/* <Form> */}
                                        <Form>
                                            <div>
                                                <h6>Check Out</h6>
                                            </div>
                                            <Card>
                                                <Row className=" m-3">
                                                    <Col lg={12} md={12} sm={12} xs={12}>
                                                        <Row>
                                                            <Col md={6} sm={12} xl={6} lg={6}>
                                                                <Row>
                                                                    <Form.Select
                                                                        aria-label="Default select example"
                                                                        className="info1"
                                                                        onChange={(e) => onSelectShift(e)}
                                                                        value={shiftId}
                                                                    >
                                                                        {/*                                   value={detailsForSecurityVendorId} */}
                                                                        {/*                                 // {...register("shift", { required: true })} */}
                                                                        {/*                                 > */}
                                                                        {/*                                   <option>Select Shift</option> */}
                                                                        <option value="">Select Shift</option>
                                                                        {shiftData.map((shift) => (<option
                                                                            key={shift.shiftId}
                                                                            value={shift.shiftId}
                                                                        >
                                                                            {shift.shiftName}
                                                                        </option>))}
                                                                        {/*                                       // <option value="2">Vendor-2</option> */}
                                                                        {/*                                       // <option value="3">Vendor-3</option> */}
                                                                        {/*                                     ))} */}
                                                                    </Form.Select>
                                                                    {/* {errors.shift && <p className='validationMsg'>Shift is Required</p>} */}
                                                                </Row>
                                                                <Row className=" mt-3">
                                                                    <Form.Control
                                                                        type="text"
                                                                        className="info1"
                                                                        placeholder="Select Emp"
                                                                        {...register("selectempci", {
                                                                            required: true,
                                                                        })}
                                                                    />
                                                                </Row>
                                                                <Row>
                                                                    {shiftIDRef.current == "" && renderLabourListCheckOut(checkOutLabourers)}
                                                                    {errors.selectempci && (
                                                                        <p className="validationMsg">
                                                                            Selecting employee is Required
                                                                        </p>)}
                                                                </Row>
                                                                <Row>
                                                                    {shiftIDRef.current != "" && renderLabourListCheckOut(checkOutLabourersByShift)}
                                                                    {errors.selectempci && (
                                                                        <p className="validationMsg">
                                                                            Selecting employee is Required
                                                                        </p>)}
                                                                </Row>
                                                            </Col>

                                                            <Col
                                                                className={"employeeCard"}
                                                                md={6}
                                                                sm={12}
                                                                xl={6}
                                                                lg={6}
                                                            >
                                                                {showEmployeeDetails}
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>

                                                <Row>
                                                    <div className="buttonProceedDiv">
                                                        <div className="container">
                                                            <div className="row p-0">
                                                                <div className="text-left p-0">
                                                                    {/*                                 {deptCheckIn.length} */}
                                                                    {departmentCheckIn === true && departmentCheckOut === false && (
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-success float-end mx-2"
                                                                            onClick={(e) => checkOutBtn(e)}
                                                                            disabled={isIndividualCheckOutLoading}
                                                                        >
                                                                            {isIndividualCheckOutLoading ? "Processing..." : "Check Out"}
                                                                        </button>)}
                                                                    {departmentCheckIn === false && departmentCheckOut === false && (
                                                                        <p className="error-msg-p">
                                                                            Labour's department Check-In
                                                                            pending.
                                                                        </p>)}
                                                                    {departmentCheckOut === true && (
                                                                        <p className="error-msg-p">
                                                                            Labour already Checked-Out.
                                                                        </p>)}
                                                                    {/* <button type="button" className="btn btn-reject float-end">Proceed</button> */}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Row>
                                            </Card>
                                        </Form>
                                    </Col>
                                </Row>
                            </Card>
                        </div>
                    </Card>
                </div>
        </Container>
        <Modal
            show={showDep}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header className="modal-header">
                {showDepCO == "" && <Modal.Title>Confirm Check-In</Modal.Title>}
                {showDepCO != "" && <Modal.Title>Confirm Check-Out</Modal.Title>}
            </Modal.Header>
            {showDepMsgI == "" && showDepCO == "" && (<Modal.Body>Please click on "Check In" to Check-In.</Modal.Body>)}
            {showDepMsgO == "" && showDepCO != "" && (
                <Modal.Body>Please click on "Check Out" to Check-Out.</Modal.Body>)}
            {showDepMsgI != "" && showDepCO == "" && (<Modal.Body>
                <img src={CheckInimg} className="check-in-img" alt=""/> <br></br>
                Check In Done Successfully !!
            </Modal.Body>)}
            {showDepMsgO != "" && showDepCO != "" && (<Modal.Body>
                <img src={CheckInimg} className="check-in-img" alt=""/> <br></br>
                Check Out Done Successfully !!
            </Modal.Body>)}
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
                {showDepMsgI == "" && showDepCO == "" && (<Button type="button" onClick={(e) => handleSubmitCheckIn(e)} disabled={isIndividualCheckInLoading}>
                    {isIndividualCheckInLoading ? "Processing..." : "Check In"}
                </Button>)}
                {showDepMsgO == "" && showDepCO != "" && (
                    <Button type="button" onClick={(e) => handleSubmitCheckOut(e)} disabled={isIndividualCheckOutLoading}>
                        {isIndividualCheckOutLoading ? "Processing..." : "Check Out"}
                    </Button>)}
            </Modal.Footer>
        </Modal>
        {/*<ToastContainer*/}
        {/*    position="top-right"*/}
        {/*    autoClose={3000}*/}
        {/*    hideProgressBar={false}*/}
        {/*    newestOnTop={false}*/}
        {/*    closeOnClick*/}
        {/*    rtl={false}*/}
        {/*    pauseOnFocusLoss*/}
        {/*    draggable*/}
        {/*    pauseOnHover*/}
        {/*/>*/}
    </div>);
}

export default Department;
